var map = {
	"./0xbtc.png": 15597,
	"./1000sats.png": 98046,
	"./1inch.png": 13357,
	"./1sol.png": 19143,
	"./1st.png": 23696,
	"./3p.png": 98627,
	"./5ire.png": 43623,
	"./REEF.png": 86912,
	"./REI.png": 40144,
	"./RONIN.png": 7184,
	"./RPL.png": 96406,
	"./aave.png": 1415,
	"./abbc.png": 65890,
	"./abt.png": 59547,
	"./ac3.png": 207,
	"./aca.png": 97165,
	"./ace.png": 23273,
	"./ach.png": 27244,
	"./acm.png": 60497,
	"./acs.png": 3759,
	"./act.png": 34736,
	"./ada.png": 34468,
	"./ada2l.png": 18922,
	"./ada2s.png": 65965,
	"./adb.png": 19743,
	"./adx.png": 68517,
	"./ae.png": 84912,
	"./aeon.png": 87679,
	"./aergo.png": 510,
	"./aeur.png": 88925,
	"./aevo.png": 71161,
	"./afc.png": 18008,
	"./afg.png": 92540,
	"./agi.png": 86761,
	"./agix.png": 82037,
	"./agla.png": 26775,
	"./agld.png": 68330,
	"./ai.png": 70012,
	"./aion.png": 36379,
	"./aioz.png": 33007,
	"./ait.png": 87586,
	"./aki.png": 90845,
	"./akro.png": 18811,
	"./akt.png": 33704,
	"./alcx.png": 64644,
	"./aleph.png": 21576,
	"./algo.png": 71783,
	"./alice.png": 54844,
	"./alis.png": 84229,
	"./alpaca.png": 60972,
	"./alpha.png": 66884,
	"./alpine.png": 14747,
	"./alt.png": 93585,
	"./alx.png": 30253,
	"./amb.png": 47304,
	"./amlt.png": 51680,
	"./amp.png": 73322,
	"./ampl.png": 34796,
	"./anc.png": 92304,
	"./anj.png": 75585,
	"./ankr.png": 70328,
	"./ant.png": 62495,
	"./ape.png": 93764,
	"./ape2l.png": 8426,
	"./ape2s.png": 52909,
	"./apex.png": 35254,
	"./aph.png": 57073,
	"./api3.png": 81745,
	"./apl.png": 6709,
	"./app.png": 17657,
	"./appc.png": 2166,
	"./aprs.png": 96968,
	"./apt.png": 65821,
	"./apw.png": 84614,
	"./apy.png": 98680,
	"./ar.png": 55103,
	"./arb.png": 91597,
	"./ardr.png": 22465,
	"./ark.png": 79148,
	"./arkm.png": 49619,
	"./armor.png": 34021,
	"./arn.png": 38257,
	"./aro.png": 24040,
	"./arpa.png": 92390,
	"./arrr.png": 61371,
	"./arty.png": 71090,
	"./asr.png": 98006,
	"./ast.png": 1088,
	"./astr.png": 29744,
	"./ata.png": 2804,
	"./atm.png": 54232,
	"./atmi.png": 12187,
	"./atom.png": 56725,
	"./atom2l.png": 44103,
	"./atom2s.png": 48944,
	"./auc.png": 16489,
	"./auction.png": 96155,
	"./audio.png": 42966,
	"./aura.png": 18923,
	"./aury.png": 90211,
	"./auto.png": 31107,
	"./ava.png": 9146,
	"./avax.png": 21608,
	"./avax2l.png": 68326,
	"./avax2s.png": 50289,
	"./awc.png": 47987,
	"./axl.png": 83869,
	"./axp.png": 28145,
	"./axs.png": 68250,
	"./azy.png": 88342,
	"./babydoge.png": 98817,
	"./bac.png": 30926,
	"./badger.png": 92267,
	"./bake.png": 7913,
	"./bal.png": 62841,
	"./band.png": 51639,
	"./bao.png": 48834,
	"./bar.png": 17127,
	"./bat.png": 85905,
	"./bay.png": 15652,
	"./bbl.png": 71916,
	"./bbr.png": 26018,
	"./bcd.png": 24143,
	"./bch.png": 44947,
	"./bcha.png": 97410,
	"./bcn.png": 56613,
	"./bco.png": 90076,
	"./bcut.png": 81152,
	"./beam.png": 88239,
	"./beamx.png": 38087,
	"./bel.png": 25933,
	"./beta.png": 70728,
	"./bf.png": 88014,
	"./bico.png": 39699,
	"./bifi.png": 39666,
	"./bix.png": 13861,
	"./blk.png": 35597,
	"./block.png": 68103,
	"./blt.png": 31082,
	"./blue.png": 29894,
	"./blur.png": 30953,
	"./blz.png": 37076,
	"./bnb.png": 14038,
	"./bnt.png": 14000,
	"./bnx.png": 99100,
	"./bob.png": 60957,
	"./boba.png": 80208,
	"./bome.png": 96461,
	"./bond.png": 91585,
	"./bondly.png": 72124,
	"./bonk.png": 80070,
	"./bonus.png": 41137,
	"./bora.png": 73440,
	"./box.png": 36455,
	"./bpt.png": 68766,
	"./brawl.png": 20740,
	"./brd.png": 3252,
	"./bsw.png": 1172,
	"./btc++.png": 83491,
	"./btc.png": 74717,
	"./btc3l.png": 96244,
	"./btc3s.png": 1091,
	"./btcd.png": 12061,
	"./btcp.png": 40681,
	"./btg.png": 95929,
	"./btmx.png": 72611,
	"./bto.png": 47105,
	"./bts.png": 11981,
	"./btt.png": 82002,
	"./bttc.png": 59539,
	"./btu.png": 3547,
	"./bu.png": 92629,
	"./bunny.png": 33348,
	"./burger.png": 90729,
	"./busd.png": 98452,
	"./bwt.png": 90499,
	"./bz.png": 40626,
	"./bznt.png": 57488,
	"./bzrx.png": 79880,
	"./c20.png": 85045,
	"./c98.png": 77392,
	"./cake.png": 54918,
	"./candy.png": 64715,
	"./capo.png": 74069,
	"./capp.png": 10658,
	"./caps.png": 58841,
	"./car.png": 20434,
	"./card.png": 86076,
	"./cat.png": 87172,
	"./cbat.png": 59634,
	"./cbk.png": 66230,
	"./cbt.png": 33121,
	"./cbx.png": 60733,
	"./cdai.png": 57021,
	"./cdt.png": 56195,
	"./cel.png": 45440,
	"./celo.png": 27893,
	"./celr.png": 26563,
	"./cennz.png": 14030,
	"./ceth.png": 13874,
	"./cfx.png": 45769,
	"./cgpt.png": 15648,
	"./chai.png": 82913,
	"./chat.png": 68196,
	"./chr.png": 72961,
	"./chrp.png": 26677,
	"./chsb.png": 84680,
	"./chz.png": 26233,
	"./city.png": 47591,
	"./ckb.png": 1664,
	"./clo.png": 92296,
	"./cloak.png": 57752,
	"./clout.png": 49059,
	"./clv.png": 1273,
	"./cmp.png": 21988,
	"./cmt.png": 7520,
	"./cnd.png": 23469,
	"./cnx.png": 60033,
	"./co.png": 79127,
	"./com.png": 35243,
	"./combo.png": 194,
	"./comp.png": 48131,
	"./coni.png": 8403,
	"./coq.png": 44839,
	"./cosm.png": 11380,
	"./coti.png": 17249,
	"./cov.png": 53320,
	"./cova.png": 99315,
	"./cover.png": 91173,
	"./cpc.png": 91408,
	"./cpool.png": 86057,
	"./cre.png": 37624,
	"./cream.png": 89694,
	"./cred.png": 48190,
	"./crep.png": 55530,
	"./cro.png": 16866,
	"./crpt.png": 30805,
	"./crv.png": 92931,
	"./cs.png": 61336,
	"./csai.png": 15258,
	"./csc.png": 43601,
	"./ctc.png": 20012,
	"./ctk.png": 89956,
	"./ctsi.png": 34119,
	"./ctt.png": 40627,
	"./ctxc.png": 10292,
	"./cusdc.png": 64432,
	"./cv.png": 65285,
	"./cvc.png": 21690,
	"./cvp.png": 9697,
	"./cvt.png": 45381,
	"./cvx.png": 58521,
	"./cwbtc.png": 14059,
	"./cyber.png": 55675,
	"./czrx.png": 55367,
	"./dadi.png": 59834,
	"./dafi.png": 64964,
	"./dag.png": 47656,
	"./dai.png": 76118,
	"./dar.png": 86629,
	"./dash.png": 98494,
	"./dat.png": 74963,
	"./data.png": 47938,
	"./datx.png": 24003,
	"./dbc.png": 67469,
	"./dcn.png": 30943,
	"./dcr.png": 45811,
	"./dct.png": 79717,
	"./ddd.png": 72516,
	"./dechat.png": 10761,
	"./default.png": 22511,
	"./default_dark.png": 7864,
	"./degen.png": 2645,
	"./dego.png": 78729,
	"./dent.png": 21669,
	"./deri.png": 89660,
	"./dexe.png": 41494,
	"./dfi.png": 24571,
	"./dft.png": 22958,
	"./dfyn.png": 46557,
	"./dgb.png": 20951,
	"./dgd.png": 93089,
	"./dgtx.png": 13917,
	"./dia.png": 77222,
	"./divi.png": 7164,
	"./dlt.png": 38364,
	"./dmail.png": 22505,
	"./dmt.png": 9863,
	"./dnt.png": 28534,
	"./dock.png": 17303,
	"./dodo.png": 50058,
	"./doge.png": 89221,
	"./dor.png": 25839,
	"./dot.png": 79897,
	"./drep.png": 19587,
	"./drgn.png": 64259,
	"./drop.png": 30581,
	"./dsrun.png": 59290,
	"./dta.png": 68697,
	"./dtr.png": 54770,
	"./dtx.png": 59720,
	"./duel.png": 36856,
	"./dusk.png": 41857,
	"./dvf.png": 4540,
	"./dxd.png": 31440,
	"./dxt.png": 41856,
	"./dydx.png": 19595,
	"./dym.png": 98778,
	"./edg.png": 58326,
	"./edo.png": 68894,
	"./edu.png": 31700,
	"./efi.png": 32670,
	"./efx.png": 59383,
	"./egld.png": 23966,
	"./egt.png": 52864,
	"./ekg.png": 68431,
	"./ekt.png": 54916,
	"./ela.png": 54424,
	"./elec.png": 76205,
	"./elf.png": 76567,
	"./emc.png": 42333,
	"./emc2.png": 92699,
	"./ena.png": 1230,
	"./eng.png": 95256,
	"./enj.png": 95581,
	"./ens.png": 20396,
	"./eos.png": 22455,
	"./eosdac.png": 99923,
	"./epx.png": 81477,
	"./ern.png": 72157,
	"./esd.png": 44556,
	"./esp.png": 19416,
	"./ess.png": 93907,
	"./etc.png": 8962,
	"./eth.png": 50849,
	"./ethfi.png": 23210,
	"./etn.png": 78711,
	"./etp.png": 50889,
	"./etz.png": 85027,
	"./eur.png": 68188,
	"./evx.png": 46599,
	"./ewt.png": 31088,
	"./exrn.png": 93913,
	"./exy.png": 79716,
	"./fab.png": 64427,
	"./farm.png": 56374,
	"./fct.png": 98683,
	"./fdusd.png": 26618,
	"./feed.png": 58102,
	"./fei.png": 79980,
	"./fet.png": 77369,
	"./fida.png": 55992,
	"./fil.png": 39565,
	"./filda.png": 89856,
	"./firo.png": 66204,
	"./flm.png": 99935,
	"./floki.png": 90273,
	"./flow.png": 97094,
	"./flux.png": 68399,
	"./for.png": 2409,
	"./forth.png": 43013,
	"./fota.png": 40214,
	"./fox.png": 82627,
	"./frax.png": 6161,
	"./frm.png": 11969,
	"./front.png": 78021,
	"./fsn.png": 3121,
	"./ft.png": 64160,
	"./ftc.png": 56233,
	"./ftm.png": 28679,
	"./ftt.png": 20998,
	"./fuel.png": 77966,
	"./fun.png": 33235,
	"./fxc.png": 76669,
	"./fxs.png": 87085,
	"./fxt.png": 14578,
	"./gal.png": 78648,
	"./gala.png": 29603,
	"./gas.png": 87295,
	"./gdc.png": 64552,
	"./gem.png": 70749,
	"./gen.png": 73190,
	"./glm.png": 18718,
	"./glmr.png": 91214,
	"./gmt.png": 12292,
	"./gmx.png": 62299,
	"./gno.png": 27314,
	"./gnt.png": 4321,
	"./gnx.png": 89405,
	"./go.png": 48936,
	"./goc.png": 80449,
	"./got.png": 65246,
	"./grin.png": 86596,
	"./grs.png": 65970,
	"./grt.png": 38477,
	"./gsc.png": 42709,
	"./gswap.png": 54214,
	"./gt.png": 7563,
	"./gtc.png": 29208,
	"./gto.png": 79668,
	"./gusd.png": 45423,
	"./gvt.png": 9209,
	"./gxs.png": 45052,
	"./hakka.png": 24244,
	"./hbar.png": 38073,
	"./hc.png": 66113,
	"./hedg.png": 76068,
	"./her.png": 11301,
	"./hex.png": 74831,
	"./hft.png": 80258,
	"./hifi.png": 2464,
	"./high.png": 4510,
	"./hive.png": 48316,
	"./hnt.png": 78410,
	"./hook.png": 9519,
	"./hot-x.png": 7454,
	"./hot.png": 77869,
	"./hpb.png": 33282,
	"./hsr.png": 50615,
	"./ht.png": 93438,
	"./hum.png": 13346,
	"./husd.png": 63138,
	"./hvn.png": 83192,
	"./hydro.png": 46022,
	"./hyn.png": 6797,
	"./hzn.png": 36428,
	"./ibat.png": 4328,
	"./icn.png": 48818,
	"./icp.png": 67324,
	"./icx.png": 43252,
	"./id.png": 78001,
	"./idai.png": 14327,
	"./idex.png": 46322,
	"./ieth.png": 75044,
	"./ignis.png": 31314,
	"./iknc.png": 70203,
	"./ilink.png": 88185,
	"./ilv.png": 79835,
	"./imx.png": 41226,
	"./inb.png": 89169,
	"./inj.png": 361,
	"./ins.png": 44568,
	"./iost.png": 44207,
	"./iota.png": 96623,
	"./iotx.png": 98558,
	"./iq.png": 7932,
	"./irep.png": 55776,
	"./iris.png": 10495,
	"./isusd.png": 25528,
	"./iusdc.png": 13390,
	"./iwbtc.png": 35101,
	"./izrx.png": 67393,
	"./jasmy.png": 98132,
	"./jnt.png": 71816,
	"./joe.png": 67834,
	"./jst.png": 58519,
	"./jto.png": 52857,
	"./juno.png": 400,
	"./jup.png": 55769,
	"./juv.png": 61743,
	"./kava.png": 87733,
	"./kcs.png": 40953,
	"./kda.png": 92822,
	"./keep.png": 53085,
	"./key.png": 93557,
	"./kick.png": 29552,
	"./kin.png": 94318,
	"./klay.png": 40813,
	"./klv.png": 57553,
	"./kmd.png": 90920,
	"./knc.png": 8522,
	"./kp3r.png": 67688,
	"./ksm.png": 68695,
	"./lamb.png": 33458,
	"./land.png": 58561,
	"./lazio.png": 23845,
	"./lba.png": 57127,
	"./lcx.png": 23793,
	"./ldo.png": 84095,
	"./lend.png": 47229,
	"./leo.png": 90260,
	"./lever.png": 3444,
	"./lina.png": 81972,
	"./link.png": 81902,
	"./lit.png": 45491,
	"./lky.png": 35952,
	"./ln.png": 27352,
	"./loka.png": 48781,
	"./loki.png": 31125,
	"./lon.png": 84939,
	"./looks.png": 25976,
	"./loom.png": 54797,
	"./lpt.png": 18272,
	"./lqd.png": 67451,
	"./lqty.png": 3506,
	"./lrc.png": 19397,
	"./lsk.png": 18970,
	"./ltc.png": 78579,
	"./lto.png": 5743,
	"./lun.png": 47149,
	"./luna.png": 83136,
	"./lunc.png": 63602,
	"./lxt.png": 29048,
	"./lym.png": 38466,
	"./magic.png": 3833,
	"./maha.png": 79905,
	"./maid.png": 6279,
	"./man.png": 69092,
	"./mana.png": 97719,
	"./manta.png": 38809,
	"./mask.png": 49766,
	"./math.png": 55380,
	"./matic.png": 64066,
	"./matter.png": 38245,
	"./mav.png": 48540,
	"./mbc.png": 63856,
	"./mbl.png": 14391,
	"./mbox.png": 15438,
	"./mc.png": 23370,
	"./mco.png": 74535,
	"./mcx.png": 86808,
	"./mda.png": 21992,
	"./mds.png": 33162,
	"./mdt.png": 17829,
	"./mdx.png": 30969,
	"./med.png": 722,
	"./medx.png": 83264,
	"./meme.png": 28598,
	"./met.png": 50114,
	"./metis.png": 8886,
	"./mfg.png": 85768,
	"./mft.png": 13075,
	"./mim.png": 68727,
	"./mina.png": 26175,
	"./mir.png": 86080,
	"./mith.png": 64988,
	"./mkr.png": 58314,
	"./mln.png": 51127,
	"./mngo.png": 93029,
	"./mob.png": 23894,
	"./mod.png": 43328,
	"./mot.png": 6064,
	"./movr.png": 51786,
	"./mpl.png": 88649,
	"./mta.png": 19896,
	"./mth.png": 41433,
	"./mtl.png": 89597,
	"./mtn.png": 87375,
	"./mvc.png": 52316,
	"./mvl.png": 73707,
	"./mvp.png": 71399,
	"./mwat.png": 91093,
	"./mwc.png": 18983,
	"./mxm.png": 94936,
	"./myb.png": 74112,
	"./nano.png": 3256,
	"./nas.png": 19322,
	"./nav.png": 9831,
	"./ncash.png": 90127,
	"./nct.png": 7907,
	"./near.png": 58788,
	"./nebl.png": 13547,
	"./nec.png": 51454,
	"./neo.png": 85202,
	"./new.png": 19722,
	"./nex.png": 12669,
	"./nexo.png": 52494,
	"./nexxo.png": 34514,
	"./nfp.png": 47936,
	"./nft.png": 93028,
	"./ngc.png": 1824,
	"./niox.png": 38964,
	"./nkn.png": 6897,
	"./nlg.png": 76429,
	"./nmr.png": 16255,
	"./noia.png": 92462,
	"./nper.png": 74881,
	"./npxs.png": 70247,
	"./nrg.png": 3923,
	"./nrve.png": 20093,
	"./ntrn.png": 30468,
	"./nu.png": 7009,
	"./nuls.png": 20646,
	"./nxs.png": 89189,
	"./nxt.png": 5962,
	"./oag.png": 38259,
	"./oax.png": 3940,
	"./ocean.png": 41710,
	"./ocn.png": 47176,
	"./ode.png": 55814,
	"./og.png": 38296,
	"./ogn.png": 99748,
	"./ohm.png": 50602,
	"./okb.png": 74892,
	"./olt.png": 58836,
	"./om.png": 83746,
	"./omg.png": 84039,
	"./one.png": 19648,
	"./ong.png": 83154,
	"./onion.png": 31979,
	"./ont.png": 15481,
	"./ooki.png": 820,
	"./op.png": 55591,
	"./open.png": 21470,
	"./opium.png": 10344,
	"./orbs.png": 33376,
	"./orc.png": 6922,
	"./ordi.png": 61056,
	"./orn.png": 18031,
	"./osmo.png": 19068,
	"./ost.png": 52690,
	"./ovc.png": 85790,
	"./oxt.png": 83211,
	"./pBTC.png": 39951,
	"./pai.png": 66370,
	"./paint.png": 22400,
	"./pal.png": 60495,
	"./par.png": 3441,
	"./part.png": 78113,
	"./pax.png": 14843,
	"./paxg.png": 17356,
	"./pay.png": 626,
	"./pbr.png": 6336,
	"./pda.png": 69581,
	"./pendle.png": 59488,
	"./people.png": 25707,
	"./pepe.png": 91634,
	"./perl.png": 62901,
	"./perp.png": 90201,
	"./phb.png": 26578,
	"./pickle.png": 98848,
	"./pivx.png": 17633,
	"./pixel.png": 78968,
	"./plDAI.png": 85242,
	"./plUSDC.png": 433,
	"./play.png": 79824,
	"./plr.png": 82366,
	"./png.png": 81673,
	"./pnk.png": 20117,
	"./pnt.png": 56706,
	"./poa.png": 2824,
	"./poe.png": 79788,
	"./pokt.png": 46316,
	"./pols.png": 8802,
	"./poly.png": 1272,
	"./polyx.png": 38242,
	"./pond.png": 80539,
	"./pool.png": 53688,
	"./portal.png": 7416,
	"./porto.png": 97032,
	"./powr.png": 91102,
	"./ppay.png": 63236,
	"./ppc.png": 29907,
	"./ppp.png": 51624,
	"./ppt.png": 80556,
	"./pre.png": 82111,
	"./premia.png": 48028,
	"./prl.png": 63038,
	"./pro.png": 65141,
	"./prom.png": 83444,
	"./pros.png": 40538,
	"./prq.png": 34187,
	"./psg.png": 96098,
	"./pst.png": 61321,
	"./pundix.png": 47318,
	"./pyr.png": 67289,
	"./pyth.png": 28503,
	"./qash.png": 48473,
	"./qbit.png": 61720,
	"./qi.png": 48332,
	"./qkc.png": 70311,
	"./qlc.png": 84222,
	"./qnt.png": 67023,
	"./qsp.png": 78772,
	"./qtum.png": 48855,
	"./quick.png": 77249,
	"./r.png": 73314,
	"./rad.png": 38897,
	"./rae.png": 98952,
	"./rare.png": 90458,
	"./rari.png": 11574,
	"./ray.png": 30964,
	"./rcn.png": 46421,
	"./rdd.png": 19074,
	"./rdn.png": 62072,
	"./rdnt.png": 64494,
	"./ren.png": 18671,
	"./rep.png": 75409,
	"./req.png": 81544,
	"./rev.png": 61159,
	"./rfox.png": 46731,
	"./rhoc.png": 39498,
	"./rif.png": 42955,
	"./rlc.png": 4005,
	"./rndr.png": 18880,
	"./rook.png": 35513,
	"./rose.png": 72899,
	"./rpx.png": 33570,
	"./rsr.png": 57513,
	"./rsv.png": 47757,
	"./rune.png": 22354,
	"./rvn.png": 88738,
	"./s.png": 94443,
	"./sai.png": 76657,
	"./salt.png": 93906,
	"./san.png": 9918,
	"./sand.png": 69064,
	"./sar.png": 74210,
	"./sc.png": 14872,
	"./scrl.png": 45782,
	"./scrt.png": 2286,
	"./sdt.png": 95059,
	"./seele.png": 26912,
	"./sefi.png": 80721,
	"./sei.png": 10973,
	"./sem.png": 79161,
	"./sfi.png": 57760,
	"./sfp.png": 12545,
	"./shib.png": 2426,
	"./shr.png": 40209,
	"./shuf.png": 25850,
	"./sia.png": 87793,
	"./skl.png": 5134,
	"./sky.png": 70819,
	"./slp.png": 61119,
	"./slt.png": 88123,
	"./smart.png": 27655,
	"./snc.png": 32738,
	"./sngls.png": 30513,
	"./snm.png": 44380,
	"./snt.png": 91085,
	"./snx.png": 11889,
	"./sol.png": 57106,
	"./soul.png": 51287,
	"./sov.png": 1080,
	"./spell.png": 54390,
	"./spn.png": 80757,
	"./srm.png": 81184,
	"./ssv.png": 34508,
	"./stake.png": 17666,
	"./steem.png": 36620,
	"./step.png": 8016,
	"./steth.png": 6038,
	"./stg.png": 19032,
	"./stmx.png": 46448,
	"./storj.png": 648,
	"./storm.png": 92167,
	"./stpt.png": 48515,
	"./strat.png": 55630,
	"./strax.png": 62082,
	"./strk.png": 42850,
	"./stx.png": 78655,
	"./sub.png": 83006,
	"./sui.png": 4205,
	"./sun.png": 74226,
	"./super.png": 22689,
	"./suqa.png": 15080,
	"./sushi.png": 97118,
	"./suter.png": 34581,
	"./swap.png": 56863,
	"./swth.png": 15600,
	"./sxdt.png": 37923,
	"./sxp.png": 31059,
	"./syn.png": 82118,
	"./sys.png": 51491,
	"./t.png": 48532,
	"./tbtc.png": 62547,
	"./tct.png": 37301,
	"./tel.png": 60647,
	"./tfuel.png": 79468,
	"./thc.png": 93039,
	"./theta.png": 30084,
	"./thr.png": 98646,
	"./tia.png": 26966,
	"./tio.png": 41032,
	"./titan.png": 22974,
	"./tkn.png": 9287,
	"./tko.png": 21598,
	"./tky.png": 99320,
	"./tlm.png": 43837,
	"./tnb.png": 62304,
	"./tnc.png": 17129,
	"./tnt.png": 47270,
	"./tomo.png": 42861,
	"./torn.png": 44401,
	"./tpay.png": 35920,
	"./trac.png": 67575,
	"./trb.png": 20420,
	"./tribe.png": 56716,
	"./trig.png": 67832,
	"./troy.png": 9652,
	"./trtl.png": 32164,
	"./tru.png": 9355,
	"./trx.png": 12398,
	"./tryb.png": 10485,
	"./tube.png": 66880,
	"./tusd.png": 75478,
	"./twt.png": 10577,
	"./ubq.png": 3066,
	"./ubt.png": 62951,
	"./uft.png": 10875,
	"./ult.png": 24005,
	"./uma.png": 68319,
	"./uncx.png": 99902,
	"./unfi.png": 60356,
	"./uni.png": 2473,
	"./unn.png": 64937,
	"./uos.png": 60199,
	"./upp.png": 85677,
	"./usdc.png": 84525,
	"./usdp.png": 63494,
	"./usds.png": 47261,
	"./usdt.png": 54466,
	"./ustc.png": 10749,
	"./utk.png": 83738,
	"./uuu.png": 2723,
	"./value.png": 72555,
	"./vanry.png": 72096,
	"./veri.png": 59358,
	"./vest.png": 79552,
	"./vet.png": 88873,
	"./vgx.png": 88811,
	"./via.png": 31192,
	"./vib.png": 76947,
	"./vibe.png": 77478,
	"./vic.png": 21738,
	"./vidt.png": 549,
	"./vikky.png": 24162,
	"./vin.png": 56143,
	"./vite.png": 63100,
	"./viu.png": 56332,
	"./vlx.png": 41938,
	"./voxel.png": 44232,
	"./vrs.png": 61199,
	"./vsp.png": 71583,
	"./vsys.png": 27223,
	"./vtc.png": 23833,
	"./vtho.png": 86311,
	"./w.png": 67439,
	"./wabi.png": 78789,
	"./wan.png": 62234,
	"./waves.png": 44762,
	"./waxp.png": 64550,
	"./wbeth.png": 96776,
	"./wct.png": 16746,
	"./wexpoly.png": 93082,
	"./whale.png": 89759,
	"./wib.png": 18446,
	"./wif.png": 59498,
	"./win.png": 24898,
	"./wing.png": 26759,
	"./wings.png": 31724,
	"./wld.png": 9807,
	"./wnxm.png": 4652,
	"./woo.png": 12141,
	"./wpr.png": 76957,
	"./wrx.png": 20193,
	"./wtc.png": 24872,
	"./wxt.png": 76163,
	"./xai.png": 34234,
	"./xas.png": 55312,
	"./xchf.png": 94815,
	"./xec.png": 11100,
	"./xem.png": 93570,
	"./xin.png": 2253,
	"./xlm.png": 14497,
	"./xlq.png": 9997,
	"./xmark.png": 26967,
	"./xmr.png": 18845,
	"./xnk.png": 84221,
	"./xno.png": 36057,
	"./xrd.png": 16478,
	"./xrp.png": 40170,
	"./xtz.png": 91926,
	"./xvg.png": 1801,
	"./xvs.png": 56829,
	"./yfi.png": 51626,
	"./ygg.png": 33663,
	"./zec.png": 80498,
	"./zen.png": 18087,
	"./zil.png": 78089,
	"./zrx.png": 73488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80129;